/**
 * 角度相关工具
 */

/**
 * 将角度类转换为10进制
 * @param angle 角度类
 * @returns {number}
 */
function angleToDecimal({degree = 0, minute = 0 , second = 0}) {
  if (!degree && !minute && !second) {
      return ''
  }
  let degreeDecimal = Math.abs(degree)
  let minuteDecimal = Math.abs(minute) / 60
  let secondDecimal = Math.abs(second) / 3600
  return (degreeDecimal + minuteDecimal + secondDecimal).toFixed(5)
}

/**
 * 将10进制角度 转换为 度分秒类
 * @param decimalAngle 10进制角度
 * @returns {Object} 度分秒的object
 */
function toAngleObj(decimalAngle) {
  let angle = new Object()
  if (!decimalAngle && decimalAngle != '0') {
      angle.degree = '', angle.minute = '', angle.second = '';
      return angle
  }
  decimalAngle = Math.abs(decimalAngle)
  angle.degree = Math.floor(decimalAngle) //度
  angle.minute = Math.floor((decimalAngle - angle.degree) * 60) //分
  angle.second = Math.round((decimalAngle - angle.degree) * 3600 % 60) //秒
  return angle
}

/**
 *  将10进制角度 转换为 度分秒字符串
 * @param decimalAngle 10进制角度
 * @returns {string}
 */
function toAngleStr(decimalAngle) {
  if (!decimalAngle) {
      return ''
  }
  let angle = toAngleObj(decimalAngle);
  return `${angle.degree}° ${angle.minute}' ${angle.second}"`
}

export default {
  angleToDecimal,
  toAngleObj,
  toAngleStr
}